
var id = "selectData";
var markup = "<symbol viewBox=\"0 0 25 25\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"selectData\">\n    <defs>\n        <path d=\"M17.8571429,5 L7.14285714,5 C5.96428571,5 5,5.8 5,6.77777778 L5,21 L12.5,18.3333333 L20,21 L20,6.77777778 C20,5.8 19.0357143,5 17.8571429,5 Z M18.9903846,19.5555556 L12.5,17.2078632 L6.00961538,19.5555556 L6.01852144,6.99999975 C6.01962258,6.44799263 6.46722301,6.00070958 7.01923077,6 L18,6 C18.5522847,5.99929092 19,6.44700617 19,6.99929092 C19,6.99952736 18.9999999,6.99976381 18.9992907,6.99999975 L18.9903846,19.5555556 L18.9903846,19.5555556 Z\" id=\"selectData_path-1\" />\n    </defs>\n    <g id=\"selectData_营销活动（fa）\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"selectData_刷新\" transform=\"translate(-1001.000000, -269.000000)\">\n            <g id=\"selectData_编组-2\" transform=\"translate(280.000000, 245.000000)\">\n                <g id=\"selectData_ICON\" transform=\"translate(721.000000, 24.000000)\">\n                    <rect id=\"selectData_矩形\" x=\"0\" y=\"0\" width=\"25\" height=\"25\" />\n                    <mask id=\"selectData_mask-2\" fill=\"white\">\n                        <use xlink:href=\"#selectData_path-1\" />\n                    </mask>\n                    <use id=\"selectData_icon/action/bookmark_border_24px\" fill-opacity=\"0.87\" fill=\"#000000\" xlink:href=\"#selectData_path-1\" />\n                    <path d=\"M8,9 L8,12 L18,12 L18,13 L7,13 L7,9 L8,9 Z\" id=\"selectData_形状结合\" fill=\"#212121\" transform=\"translate(12.500000, 11.000000) rotate(-45.000000) translate(-12.500000, -11.000000) \" />\n                </g>\n            </g>\n        </g>\n    </g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
